import { FC } from 'react';

import { CategoryContentProps } from './types';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

const Content: FC<CategoryContentProps> = ({ location }) => (
  <>
    <h2>{`CallAPro${location} Electrical Services: Repair, Installation, Upgrades, Hook-Ups & Wiring`}</h2>
    <p>
      {
        "If you are looking for an electrician near you, you've come to the right place! From installations and  repairs to wiring and upgrades, our electricians can help with any of the following services:"
      }
    </p>
    <section>
      <h3>Services</h3>
      <ul>
        <li>Appliance Lines</li>
        <li>Attic Fans</li>
        <li>Ceiling Fans</li>
        <li>Circuit Breakers</li>
        <li>Code Corrections</li>
        <li>Dedicated Circuits</li>
        <li>Doorbells</li>
        <li>Electrical Panels</li>
        <li>EV Chargers</li>
        <li>Exhaust Fans</li>
        <li>Fire &amp; Smoke Alarms</li>
        <li>Fuse Boxes</li>
        <li>Generators</li>
        <li>Indoor Lighting</li>
        <li>Landscape Lighting</li>
        <li>Lighting Fixtures</li>
        <li>Pools &amp; Hot Tubs</li>
        <li>Outlets &amp; GFCI</li>
        <li>Outdoor Lighting</li>
        <li>Safety Inspections</li>
        <li>Security Systems</li>
        <li>Smart Home Wiring</li>
        <li>Smoke Detectors</li>
        <li>Subpanels</li>
        <li>Surge Protectors</li>
        <li>Switches &amp; Dimmers</li>
        <li>Wiring &amp; Rewiring</li>
      </ul>
    </section>
    <section>
      <h3>{`CallAPro${location}: The Trusted Name For Local Electricians`}</h3>
      <p>
        {"No matter what your electrical service needs are, no job is too big or small for CallAPro's Electricians. Contact us  today at "}
        <TrackedPhoneNumber />
        {' for 24/7 same-day service and a no-obligation quote.'}
      </p>
    </section>
    <section>
      <h3>{'Risk-Free Quotes'}</h3>
      <p>
        {
          'Forget about surprise charges or hidden costs. Before work begins, your electrician will provide accurate, up-front  pricing that outlines the scope of work and parts needed for your project.'
        }
      </p>
    </section>
    <section>
      <h3>{'Fast, Same Day Service'}</h3>
      <p>
        {
          "Scheduling an electrician should be simple! We know your time is valuable. That's why we offer 24/7 customer support,  same day service and flexible appointment times that fit your schedule."
        }
      </p>
    </section>
    <section>
      <h3>{'24-Hour Emergency Repairs'}</h3>
      <p>
        {
          "We understand how important it is to get your electrical system back up and running quickly. To best serve you, we  have technicians available 24-hours, 7 days a week — And our trucks are fully stocked, so we're ready to fix any home  electrical problem in just a single visit."
        }
      </p>
      <p>
        {`CallAPro${location} has an electrician in your area! Call today at `}
        <TrackedPhoneNumber />
        {`.`}
      </p>
    </section>
  </>
);

export default Content;
